import { Component, inject } from '@angular/core';
import { WaitingScreenComponent } from '../../waiting-screen/waiting-screen.component';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import { ToolbarComponent } from '../../toolbar/toolbar.component';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-default-layout',
    templateUrl: './default-layout.component.html',
    styles: [],
    imports: [ToolbarComponent, RouterOutlet, WaitingScreenComponent]
})
export class DefaultLayoutComponent {
  private readonly route = inject(ActivatedRoute);


  showInscription: boolean;

  constructor() {
    const route = this.route;

    route.data.pipe(takeUntilDestroyed()).subscribe(data => {
      this.showInscription = data.showInscription;
    });
  }
}
